"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_components_1 = require("@gamepark/react-components");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var Menu_1 = require("../Menu");
var GameMode_1 = __importDefault(require("../Types/GameMode"));
var useGiveUp_1 = __importDefault(require("./useGiveUp"));
function GiveUpButton() {
    var t = react_i18next_1.useTranslation().t;
    var giveUp = useGiveUp_1.default()[0];
    var _a = react_2.useState(false), displayPopup = _a[0], setDisplayPopup = _a[1];
    var onGiveUp = function () {
        giveUp();
        setDisplayPopup(false);
    };
    var gameMode = react_redux_1.useSelector(function (state) { return state.gameMode; });
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("button", __assign({ css: [Menu_1.menuButtonCss, buttonCss], onClick: function () { return setDisplayPopup(true); } }, { children: [jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFlag }, void 0), t('Give up')] }), void 0),
            jsx_runtime_1.jsxs(react_components_1.Dialog, __assign({ open: displayPopup, css: Menu_1.menuDialogCss, onBackdropClick: function () { return setDisplayPopup(false); } }, { children: [jsx_runtime_1.jsx("h2", { children: t('Give up the game') }, void 0),
                    jsx_runtime_1.jsx("p", { children: t('give-up.dialog.p1') }, void 0),
                    jsx_runtime_1.jsx("p", { children: gameMode === GameMode_1.default.COMPETITIVE ?
                            t('give-up.dialog.p2') :
                            t('give-up.dialog.p3') }, void 0),
                    jsx_runtime_1.jsxs("div", __assign({ css: buttonLineCss }, { children: [jsx_runtime_1.jsx("button", __assign({ css: [Menu_1.menuButtonCss, inDialogButton], onClick: function () { return setDisplayPopup(false); } }, { children: t('Cancel') }), void 0),
                            jsx_runtime_1.jsxs("button", __assign({ css: [Menu_1.menuButtonCss, buttonCss, inDialogButton], onClick: onGiveUp }, { children: [jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_regular_svg_icons_1.faFlag }, void 0), t('Give up')] }), void 0)] }), void 0)] }), void 0)] }, void 0));
}
exports.default = GiveUpButton;
var buttonCss = react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7;\n  }\n\n  &:active {\n    background: #ffbebe;\n  }\n"], ["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7;\n  }\n\n  &:active {\n    background: #ffbebe;\n  }\n"])));
var buttonLineCss = react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 1em;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: 1em;\n  display: flex;\n  justify-content: space-between;\n"])));
var inDialogButton = react_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=GiveUpButton.js.map